var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{ref:"voiceDisputeForm",attrs:{"form-data":_vm.formData,"default-values":_vm.fieldValues},on:{"onSubmitForm":_vm.onSubmitForm,"updateOnSearch":_vm.onSearch,"onChange":_vm.onFormChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }